import useConfigList from '../../../../hooks/useConfigList'
import useNavigateNext from '../../../../hooks/useNavigateNext'
import useUpdateReportDoc from '../../../../hooks/useUpdateReportDoc'
import { MentalStrategiesFormState } from '../utils/types'

export const useMentalStrategiesFormState = (): MentalStrategiesFormState => {
  const items = useConfigList('mentalStrategies')
  const navNext = useNavigateNext()
  const updateReport = useUpdateReportDoc()

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    updateReport({ mentalStrategies: true })
    navNext()
  }

  const lists = [
    {
      fieldId: 'mentalStrategyId',
      label: 'Strategy',
      items,
      id: 'mentalStrategies',
    },
  ]

  return {
    handleSubmit,
    lists,
  }
}
